import React from 'react';
import { Grid } from '@mui/material';
import MemoryEditSideNav from './MemoryEditSideNav';
import MemoryEditContent from './MemoryEditContent';
import { useUserStore } from 'stores';
import { useMemoryByID } from 'hooks/memory/useMemoryByID';
import { useMemoryEditContext } from 'hooks/common';

function MemoryQAContainer() {
  const [activeMemoryChatID, setActiveMemoryChatID] =
    React.useState<string>('');
  const [selectedNavListItemID, setSelectedNavListItemID] = React.useState<
    number | null
  >(null);
  const { memoryID } = useMemoryEditContext();
  const { memory } = useMemoryByID(memoryID);

  const currentUserID = useUserStore(
    React.useCallback((state) => state.currentUserID, [])
  );

  const isRestricted = memory?.meta.user.permissions?.canUpdate;

  const handleSideNavItemClick = (sideNavItemIndex: number) => {
    setSelectedNavListItemID(sideNavItemIndex);
  };

  const closeSideNav = () => {
    setSelectedNavListItemID(null);
  };

  return (
    <Grid container>
      {currentUserID && !isRestricted && (
        <MemoryEditSideNav
          memoryID={memoryID}
          selectedNavListItemID={selectedNavListItemID}
          setSelectedNavListItemID={setSelectedNavListItemID}
          handleSideNavItemClick={handleSideNavItemClick}
          closeSideNav={closeSideNav}
          onMemoryChatClick={setActiveMemoryChatID}
          activeMemoryChatID={activeMemoryChatID}
        />
      )}
      <Grid
        item
        pl={currentUserID ? '4rem' : '0'}
        mt='6rem'
        md={12}
        height='calc(100vh - 6rem)'
        bgcolor={(theme) => theme.palette.bgGray.light}
      >
        <MemoryEditContent
          memoryID={memoryID}
          activeMemoryChatID={activeMemoryChatID}
        />
      </Grid>
    </Grid>
  );
}

export default MemoryQAContainer;
